import { environment } from 'src/environments/environment';

export const html = String.raw;

export const DEFAULT_TABLE_ROWS = 50;

export function SERVICE_LOOKUP(serviceName: keyof typeof environment.api) {
	const retrieveEndpoints = JSON.parse(localStorage.getItem('serviceBackendEndpoints')!);
	if (retrieveEndpoints != null) {
		return retrieveEndpoints.find((service: any) => service.serviceName === serviceName);
	}
}
